export default __webpack_public_path__ + "static/media/orangeTheme-girl.d0ad58be.svg";